"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const reselect_1 = require("reselect");
const createEntitiesSelectors_1 = __importDefault(require("./createEntitiesSelectors"));
const constant = (x) => () => x;
const noModelSpecified = () => {
    console.warn(`You attempted to "selectCurrent" user but no User model was specified.
This will result with null value being returned even if a user is logged in. To fix this,
please make sure that you pass a valid Model and collection name to createCurrentUserSelectors().`);
};
const createCurrentUserSelectors = (collection, { Model, prefix = 'ddp', transform } = {}) => {
    // NOTE: We are intentially not passing Model here, because the actual model
    //       will only be created later on, when entity is merged with ddp.currentUser.user object.
    const userSelectorCreators = (0, createEntitiesSelectors_1.default)(collection, {
        prefix,
        transform,
    });
    const selectCurrentUserState = (state) => state[prefix] && state[prefix].currentUser;
    const selectCurrentUserId = (0, reselect_1.createSelector)(selectCurrentUserState, (state) => state && state.userId);
    const selectCurrentUser = (0, reselect_1.createSelector)(selectCurrentUserState, (state) => state && state.user);
    const selectCurrent = userSelectorCreators
        ? (0, reselect_1.createSelector)(userSelectorCreators.one.whereIdEquals(selectCurrentUserId), selectCurrentUser, (user, rawUser) => {
            if (user || rawUser) {
                if (Model) {
                    return new Model(Object.assign(Object.assign({}, rawUser), user));
                }
                return Object.assign(Object.assign({}, rawUser), user);
            }
            return undefined;
        })
        : noModelSpecified;
    const selectIsLoggingIn = (0, reselect_1.createSelector)(selectCurrentUserState, (state) => !!(state && state.isLoggingIn));
    // Example usage would be:
    //
    // current(User).user()
    // current(User).userId()
    // current(User).isLoggingIn()
    return {
        user: constant(selectCurrent),
        userId: constant(selectCurrentUserId),
        isLoggingIn: constant(selectIsLoggingIn),
        // LEGACY
        getIsLoggingIn: selectIsLoggingIn,
        getCurrent: selectCurrent,
        getCurrentId: selectCurrentUserId,
    };
};
exports.default = createCurrentUserSelectors;
//# sourceMappingURL=createCurrentUserSelectors.js.map